export const POLISH_HOLIDAYS = {
  // 2025
  '2025-01-01': 'Nowy Rok',
  '2025-01-06': 'Trzech Króli',
  '2025-04-20': 'Wielkanoc',
  '2025-04-21': 'Poniedziałek Wielkanocny',
  '2025-05-01': 'Święto Pracy',
  '2025-05-03': 'Święto Konstytucji 3 Maja',
  '2025-06-08': 'Zielone Świątki',
  '2025-06-19': 'Boże Ciało',
  '2025-08-15': 'Wniebowzięcie NMP',
  '2025-11-01': 'Wszystkich Świętych',
  '2025-11-11': 'Święto Niepodległości',
  '2025-12-24': 'Wigilia',
  '2025-12-25': 'Boże Narodzenie',
  '2025-12-26': '2. dzień Bożego Narodzenia',
  // 2026
  '2026-01-01': 'Nowy Rok',
  '2026-01-06': 'Trzech Króli',
  '2026-04-05': 'Wielkanoc',
  '2026-04-06': 'Poniedziałek Wielkanocny',
  '2026-05-01': 'Święto Pracy',
  '2026-05-03': 'Święto Konstytucji 3 Maja',
  '2026-05-24': 'Zielone Świątki',
  '2026-06-04': 'Boże Ciało',
  '2026-08-15': 'Wniebowzięcie NMP',
  '2026-11-01': 'Wszystkich Świętych',
  '2026-11-11': 'Święto Niepodległości',
  '2026-12-24': 'Wigilia',
  '2026-12-25': 'Boże Narodzenie',
  '2026-12-26': '2. dzień Bożego Narodzenia',
  // 2027
  '2027-01-01': 'Nowy Rok',
  '2027-01-06': 'Trzech Króli',
  '2027-03-28': 'Wielkanoc',
  '2027-03-29': 'Poniedziałek Wielkanocny',
  '2027-05-01': 'Święto Pracy',
  '2027-05-03': 'Święto Konstytucji 3 Maja',
  '2027-05-16': 'Zielone Świątki',
  '2027-05-27': 'Boże Ciało',
  '2027-08-15': 'Wniebowzięcie NMP',
  '2027-11-01': 'Wszystkich Świętych',
  '2027-11-11': 'Święto Niepodległości',
  '2027-12-24': 'Wigilia',
  '2027-12-25': 'Boże Narodzenie',
  '2027-12-26': '2. dzień Bożego Narodzenia',
};

export const LEAVE_TYPES = {
  vacation: { label: 'Urlop wypoczynkowy', color: '#e8a000', bg: '#fff8e6' },
  on_demand: { label: 'Urlop na żądanie', color: '#2d6a1f', bg: '#eaf4e6' },
  sick: { label: 'Zwolnienie lekarskie', color: '#c0392b', bg: '#fdecea' },
  other: { label: 'Inne', color: '#666', bg: '#f5f5f5' },
};

export const STATUS_LABELS = {
  pending: { label: 'Oczekuje', color: '#e8a000', bg: '#fff8e6' },
  approved: { label: 'Zatwierdzony', color: '#2d6a1f', bg: '#eaf4e6' },
  rejected: { label: 'Odrzucony', color: '#c0392b', bg: '#fdecea' },
};

export function isHoliday(dateStr) {
  return !!POLISH_HOLIDAYS[dateStr];
}

export function isWeekend(date) {
  const d = new Date(date + 'T00:00:00');
  return d.getDay() === 0 || d.getDay() === 6;
}

export function isWorkDay(dateStr) {
  return !isWeekend(dateStr) && !isHoliday(dateStr);
}

export function countWorkDays(from, to) {
  let count = 0;
  let current = new Date(from + 'T00:00:00');
  const end = new Date(to + 'T00:00:00');
  while (current <= end) {
    const ds = current.toISOString().slice(0, 10);
    if (isWorkDay(ds)) count++;
    current.setDate(current.getDate() + 1);
  }
  return count;
}

export function formatDate(dateStr) {
  if (!dateStr) return '';
  const [y, m, d] = dateStr.split('-');
  return `${d}.${m}.${y}`;
}

export function toDateStr(date) {
  return date.toISOString().slice(0, 10);
}

export const MONTH_NAMES = ['Styczeń','Luty','Marzec','Kwiecień','Maj','Czerwiec','Lipiec','Sierpień','Wrzesień','Październik','Listopad','Grudzień'];
export const DAY_NAMES = ['Pn','Wt','Śr','Cz','Pt','So','Nd'];
